var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-loader page-loader-base"},[_c('div',{staticClass:"blockui"},[_c('span',[_vm._v("Please wait...")]),_c('span',[_c('b-spinner',{attrs:{"variant":"primary","label":"Please wait..."}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }